const LISTE_RETROCESSION = {
  title: 'Liste des rétrocessions',
  breadcrumb: {
    liste: 'Liste rétrocession',
  },
  tab: {
    code: 'Code facture',
    etat: 'Etat facture',
    date: 'Date facture',
    montantHt: 'Montant HT',
    montantTtc: 'Montant TTC',
    annonceur: 'Annonceur(s)',
    agence: 'Agence',
    sousType: 'Type',
    libelleRegroupement: 'Produit',
    totalHtLoc: 'Total HT location',
    pourcentageConcessionnaire: '% concession',
    bailleur: 'Bailleur',
    pourcentageRetrocession: '% rétrocession',
    retrocession: 'Rétrocession',
  },
  filtre: {
    code: 'Code(s) facture',
    annonceur: 'Annonceur(s)',
    etat: 'Etat(s)',
    type: 'Type(s)',
    libelleRegroupement: 'Produit(s)',
    bailleur: 'Bailleur(s)',
    agence: 'Agence(s)',
  },
};

export default LISTE_RETROCESSION;
